import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  risks: [],
  risksStatus: IDLE,
  totalRisks: 0,

  searchRisksResults: [],
  searchRisksStatus: IDLE,

  exportRisksStatus: IDLE,

  lastVisitedRiskId: null
};

const risksSlice = createSlice({
  name: 'risks',
  initialState,
  reducers: {
    getRisks(state) {
      state.risksStatus = LOADING;
    },
    getRisksSucceeded(state, action) {
      state.risksStatus = SUCCEEDED;
      state.risks = action.payload.risks;
      state.totalRisks = action.payload.total;
    },
    getRisksFailed(state) {
      state.risksStatus = FAILED;
    },

    searchRisks(state) {
      state.searchRisksStatus = LOADING;
    },
    searchRisksSucceeded(state, action) {
      state.searchRisksStatus = SUCCEEDED;
      state.searchRisksResults = action.payload;
    },
    searchRisksFailed(state) {
      state.searchRisksStatus = FAILED;
    },
    resetSearchRisks(state) {
      state.searchRisksResults = [];
      state.searchRisksStatus = IDLE;
    },

    exportRisks(state) {
      state.exportRisksStatus = LOADING;
    },
    exportRisksSucceeded(state) {
      state.exportRisksStatus = SUCCEEDED;
    },
    exportRisksFailed(state) {
      state.exportRisksStatus = FAILED;
    },

    resetRisks(state) {
      state.risks = [];
      state.totalRisks = 0;
    },

    setLastVisitedRiskId(state, action) {
      state.lastVisitedRiskId = action.payload.riskId;
    },
    resetLastVisitedRiskId(state) {
      state.lastVisitedRiskId = null;
    },

    reloadRisks() {}
  }
});

export const {
  getRisks,
  getRisksSucceeded,
  getRisksFailed,
  searchRisks,
  searchRisksSucceeded,
  searchRisksFailed,
  resetSearchRisks,
  exportRisks,
  exportRisksSucceeded,
  exportRisksFailed,
  resetRisks,
  setLastVisitedRiskId,
  resetLastVisitedRiskId,
  reloadRisks
} = risksSlice.actions;

export default risksSlice.reducer;
